import {combineReducers, configureStore} from "@reduxjs/toolkit"

import appStateReducer from "./AppStateSlice";

const appReducer = combineReducers({
  appState: appStateReducer,
});

export const store = configureStore({reducer: appReducer, middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: false,
  }),});

export type RootState = ReturnType<typeof appReducer>
export type AppDispatch = typeof store.dispatch;
